module.exports = __webpack_public_path__ + "static/media/landing.015a21a8.png";